export default __webpack_public_path__ + "static/media/premium-drawingtool.b8379ac3.jpg";